import { render } from "./FormMV2.vue?vue&type=template&id=2314bda0&scoped=true"
import script from "./FormMV2.vue?vue&type=script&lang=js"
export * from "./FormMV2.vue?vue&type=script&lang=js"

import "./FormMV2.vue?vue&type=style&index=0&id=2314bda0&scoped=true&lang=css"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2314bda0"]])

export default __exports__